import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import projects from './projectData';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const project = projects.find(p => p.id === parseInt(id));

  if (!project) {
    return (
      <div className="project-detail-container">
        <div className="error-message">
          <h2>Project not found</h2>
          <button onClick={() => navigate('/')} className="btn btn-primary">
            Back to Projects
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="project-detail-container">
      <div className="project-detail-header">
        <button 
          onClick={() => navigate('/')} 
          className="back-button"
        >
          ← Back
        </button>
        <h1>{project.title}</h1>
        <p>{project.description}</p>
      </div>

      <div className="project-detail-images-container">
        {project.detailImages && project.detailImages.length > 0 ? (
          <div className="images-block">
            {project.detailImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`${project.title} - Image ${index + 1}`}
                className="project-detail-image"
              />
            ))}
          </div>
        ) : (
          <div className="no-images">
            <p>No images available for this project</p>
          </div>
        )}
      </div>

      <div className="project-info">
        <div className="project-technologies">
          <h3>Technologies Used:</h3>
          <div className="tech-tags">
            {project.technologies.map((tech, index) => (
              <span key={index} className="tech-tag">{tech}</span>
            ))}
          </div>
        </div>

        <div className="project-links">
          {project.liveLink && (
            <a 
              href={project.liveLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          )}
          {project.githubLink && (
            <a 
              href={project.githubLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              View Code
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
